<div class="container" [class.delete]="isDelete">
  <mat-expansion-panel
    class="mat-elevation-z0"
    [expanded]="!collapsed"
    [disabled]="!collapsed"
  >
    <mat-expansion-panel-header
      >{{ record.ttlnm
      }}<mat-icon
        *ngIf="!!record.noteid && !duplicate"
        svgIcon="done"
        aria-hidden="false"
        aria-label="入力済"
      ></mat-icon
    ></mat-expansion-panel-header>
    <div class="checkbox-field">
      <mat-checkbox [formControl]="summary" disableRipple (change)="onChange()"
        >サマリー</mat-checkbox
      >
      <mat-checkbox [formControl]="handover" disableRipple (change)="onChange()"
        >申し送り</mat-checkbox
      >
    </div>
    <app-datetime-field
      label="開始日時"
      [form]="startDate"
      (formChange)="[onCaretimeChange(), compareDate(), onChange()]"
    ></app-datetime-field>
    <app-caretime-field
      label="介助時間"
      [form]="caretime"
      (formChange)="[onCaretimeChange(), onChange()]"
    ></app-caretime-field>
    <app-datetime-field
      label="終了日時"
      [form]="endDate"
      (formChange)="[compareDate(), onChange()]"
    >
      <mat-error *ngIf="endDate.hasError('compareDate')"
        >終了日時は開始日時より後の日時を入力してください</mat-error
      >
    </app-datetime-field>
    <app-search-select-field
      *ngIf="hasStaffList"
      label="実施者"
      [staffList]="staffList"
      [form]="odrstfcd"
      (staffChange)="onChange()"
    ></app-search-select-field>
    <hr />
  </mat-expansion-panel>
  <ng-container *ngIf="noteTitleParams">
    <lib-note-title [params]="noteTitleParams"></lib-note-title>
  </ng-container>
  <ng-content></ng-content>
</div>
